/** Public client id for display/copy (XC-…) — uppercase. */
export function formatPublicIdDisplay(id?: string | null): string {
  if (id == null) return ''
  const t = id.trim()
  return t ? t.toUpperCase() : ''
}
